import React, { useState } from "react";
import style from './proReportCard.module.scss';
import { Link } from "react-router-dom"
import toPersianNumber from "../../../helpers/actions/toPersianNumber"
import { numberWithCommas } from "../../../helpers/actions/splitNumberWithComma";

const ProReportCard = (props) => {

    const [moreInfo, setMoreInfo] = useState(false)

    const calculateLines = text => {
        if (text.length < 88) {
            return text
        } else {
            return text.substr(0, 80) + '...'
        }
    }

    return (
        <div className={style.wrapper}>
            <div className={style.newFlexWrapper}>
                <div className={`${style.flexItem} ${style.flexItem303}`}>
                    <div className={style.nameStyle}>
                        <Link className={style.name} style={{ textDecoration: "none" }} to={{ pathname: `https://www.digikala.com/product/dkp-${props.data.product[0].DKP}` }} target="_blank">
                            <div className={style.nameWrapper}>
                                <p
                                    className={style.realName}
                                    data-content={!props.data.product[0].newName.split(' | ')[1].includes('گارانتی')
                                        &&
                                        !props.data.product[0].newName.split(' | ')[1].includes('تضمین')
                                        ?
                                        '(' + toPersianNumber(props.data.product[0].newName.split(' | ')[1]) + ')'
                                        :
                                        ''}
                                >
                                    {calculateLines(toPersianNumber(props.data.product[0].newName))}
                                </p>

                            </div>
                        </Link>
                    </div>

                    <div className={style.DKPStyle}>
                        <p>DKPC - {toPersianNumber(props.data.product[0].DKPC)}</p>
                        <p className={style.DKPSeprator}></p>
                        <Link className={style.name} style={{ textDecoration: "none" }} to={{ pathname: `https://www.digikala.com/product/dkp-${props.data.product[0].DKP}` }} target="_blank">
                            <p>DKP - {toPersianNumber(props.data.product[0].DKP)}</p>
                        </Link>
                        <p className={style.DKPSeprator}></p>
                        <p>{props.data.product[0].supplierCode ? toPersianNumber(props.data.product[0].supplierCode) : '--'}</p>
                    </div>
                    <div className={style.channelPromotion}>
                        {props.data && props.data.channel ? <p className={style.channelText}>{props.data.channel}</p> : <p> </p>}
                    </div>
                </div>
                <div className={style.flexItem42}>
                    <p className={style.priceStyle}>{toPersianNumber(props.data.count)}</p>
                </div>
                {props.type == 'returned' ?
                    <div className={style.flexItem42}>
                        <p className={style.priceStyle}>{toPersianNumber(props.data.return)}</p>
                    </div>
                    :
                    null}
                <div className={style.flexItem}><p className={style.priceStyle}>{toPersianNumber(numberWithCommas(props.data.prices))}</p></div>
                <div className={style.flexItem}><p className={style.priceStyle}>{toPersianNumber(numberWithCommas(props.data.profit))}</p></div>
                <div className={style.flexItem}>
                    <div
                        className={style.moreDetails}
                        onClick={() => props.toggleReportDetail(props.data._id)}
                    >
                        جزئیات بیشتر
                    </div>
                </div>
                <div className={style.flexItem42}>
                    {/* More Info Mark */}
                    <div
                        className={!moreInfo ? style.moreInfoArrow : style.moreInfoArrowActive}
                        onClick={() => setMoreInfo(!moreInfo)}
                    >u</div>
                </div>
            </div>
            {moreInfo ?
                <div>
                    <div className={style.thirdRow}>
                        <div className={style.col}>
                            <p className={style.label}>موجودی قابل فروش</p>
                            <p className={style.priceNormalizer}>{props.data.product[0].sellerStock ? toPersianNumber(numberWithCommas(props.data.product[0].sellerStock)) : '--'}</p>
                        </div>
                        <div className={style.col}>
                            <p className={style.label}>موجودی دیجی‌کالا</p>
                            <p className={style.priceNormalizer}>{props.data.product[0].digikalaStock ? toPersianNumber(numberWithCommas(props.data.product[0].digikalaStock)) : '--'}</p>
                        </div>
                        <div className={style.col}>
                            <p className={style.label}>تعداد رزرو شده</p>
                            <p className={style.priceNormalizer}>{props.data.product[0].reservedStock ? toPersianNumber((props.data.product[0].reservedStock)) : '--'}</p>
                        </div>
                        <div className={style.col}>

                        </div>
                        <div className={style.col}>
                            <button
                                className={style.proEditButton}
                                onClick={() => props.threeDotHandler(props.data._id)}
                            >
                                تنظیمات پیشرفته
                            </button>
                        </div>
                    </div>
                </div>
                : null}
        </div>
    )
}
export default ProReportCard

